<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-card-group class="justify-content-center" v-if="step === 0">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h4 class="float-right"><b>Paso 1/3</b></h4><br/><br/>
                <h3>
                  Registro
                  <br/>                  
                </h3>
                <p class="text-muted">Ingrese su código de productor u organizador (agente)</p>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-user"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="number"
                    class="form-control"
                    placeholder="Código de productor u organizador (agente)"
                    autocomplete="off"
                    v-model="payload.cod_agente"
                    @blur="$v.payload.cod_agente.$touch"
                    :state="$v.payload.cod_agente.$dirty ? !$v.payload.cod_agente.$invalid : null"
                  />
                </b-input-group>
                <b-row>
                  <b-col class="text-right">
                    <b-button variant="link" to="/login" class="px-4 btn-action ">
                      Cancelar
                      <i class="fa fa-cancel"></i>
                    </b-button>
                    <b-button variant="primary" class="px-4 btn-action " @click="controlCode()">
                      Aceptar
                      <i class="fa fa-chevron-right"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-card-group>
      <EmailConfirmation :emailagente="this.emailagente" :payload="this.payload" v-if="step === 1 && passwordSuccess">        
      </EmailConfirmation>
    </div>
  </div>
</template>

<script>
import validarCuit from '@/helpers/ValidacionCuit';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import EmailConfirmation from '@/pages/Auth/EmailConfirmation';

export default {
  components: {
    EmailConfirmation,
  },
  data() {
    return {
      step: 0,      
      questions: {},
      emailagente: null,
      noPermitido:[102,146,419,422,10002,10050,10390,10394,100058,100059,100084,100085,100337,100338,100410,100605,100662,100766,100767,100796,100797,100409,100798,100655,100799,100800,100801,100802,100803,100804,100805,100806,100807,100808,100809,100810,100811,100830,100831,100885,100889,100895,100904,100917,100918,100919,100968,101033,101077,101200,101245,101246,101248,101250,101253,101255,101257,101259,101260,101263,101265,100085,100811,101402,100831,100084,100662,100830,101200,101403,101404,101598,101800,101267,101269,101271,101273,101403,101404,101514,101587,101598,101800,101916],
      payload: {
        cod_agente: '',
        nombre: '',
        apellido: '',
        email: ''
      },
      passwords: {
        password: '',
        password_confirmation: ''
      },
      verifyError: false,
      passwordSuccess: false,
      authData: {}
    };
  },
  validations: {
    payload: {
      cod_agente: { required }
    },
    passwords: {
      password: { required, minLength: minLength(8) },
      password_confirmation: { required, sameAsPassword: sameAs('password') }
    }
  },

  methods: {
    sumStep(number) {
      this.step += number;
    },        
    controlCode: async function() {
      this.$v.payload.cod_agente.$touch();

      if (this.$v.payload.cod_agente.$invalid) {
        this.$toast.error('Revise los campos requeridos', 'Error');
        return null;
      }

      if (this.noPermitido.includes(parseInt(this.payload.cod_agente))){
        this.$toast.error('No puede continuar con el registro. Por favor, comuníquese con la administración.', 'Imposible Continuar');
        return;
      }

      // obtener datos verdaderos y falsos para verificacion de identidad

      let loader = this.$loading.show();

      let identificador = 'codigo';
      if (validarCuit(this.payload.cod_agente)) {
        identificador = 'cuit';
      }
      /*cambiar
      this.sumStep(1);
      this.passwordSuccess = true;
      loader.hide();
      return;    
      hasta aqui*/  
      await this.$api(`auth/agente/${this.payload.cod_agente}?identificador=${identificador}`)
        .then((response) => {
          this.sumStep(1);
          this.passwordSuccess = true;
          this.emailagente = response.data.email_agente
        })
        .catch(err => {
          this.$toast.error(err.response.data.message);
        });
      loader.hide();
    }
  },
  filters: {
    upper(val) {
      return val.toUpperCase();
    },

    lower(val) {
      return val.toLowerCase();
    }
  },

  created() {
    const cod_agente = this.$route.params.cod_agente;

    if (cod_agente) {
      this.payload.cod_agente = cod_agente;
      this.controlCode();
    }
  }
};
</script>


<style scoped>
@media (max-width: 768px) {
  .btn-action {
    width: 100%;

  }
}
</style>